import { UserType } from 'src/pages/types';
import { rootReducer } from '..';

type RootState = ReturnType<typeof rootReducer>;

export const userSelector = (state: RootState): UserType | null => state.user;

export const userPassedOrSkipOnBoardingSelector = (state: RootState) =>
  (state?.user?.onBoardingAnswers && Object.keys(state?.user?.onBoardingAnswers).length > 0) ||
  state?.user?.is_viewed_specialist_list;

export const getUserOnBoardingAnswers = (state: RootState) =>
  Object.keys(state?.onBoarding?.selectedAnswers).length
    ? state.onBoarding.selectedAnswers
    : state?.user?.onBoardingAnswers;
